import styled from 'styled-components'
import { css } from '../util'
import { cssTypes } from '../types'

/**
 * @namespace TableBody
 * @desc Primitive styled-component 💅
 * @return {Function} React component
 */
const TableBody = styled.tbody`
  ${css};
`

/**
 * @name defaultProps
 * @memberof TableBody
 * @desc Primitive's default properties
 */
TableBody.defaultProps = {}

/**
 * @name propTypes
 * @memberof TableBody
 * @desc Primitive's prop type definitions
 */
TableBody.propTypes = {
  ...cssTypes,
}

/** @component */
export default TableBody
